var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose"},[_c('p',{staticClass:"tips"},[_vm._v("如果点击无响应，可能是您还未安装该APP")]),_vm._l((_vm.mapList),function(item,index){return _c('div',{key:index,staticClass:"list",on:{"click":function($event){return _vm.toMapApp(item.id)}}},[_vm._v(" "+_vm._s(item.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }